var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{class:_vm.pathClasses,attrs:{"d":_vm.pathDrawn,"transform":_vm.centerTransform}})}
var staticRenderFns = []

export { render, staticRenderFns }